export default __webpack_public_path__ + "static/media/asset-bnb.30ddcde6.svg";